
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface BrandVoiceSectionProps {
  brandVoice: string;
  updateBusinessData: (key: string, value: any) => void;
}

const BrandVoiceSection: React.FC<BrandVoiceSectionProps> = ({ 
  brandVoice, 
  updateBusinessData
}) => {
  const onChange = (value: string) => {
    updateBusinessData('brandVoice', value);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="brand-voice">Brand Voice</Label>
      <Textarea
        id="brand-voice"
        placeholder="Professional and authoritative? Friendly and casual? Innovative and bold?"
        className="resize-none"
        rows={4}
        value={brandVoice}
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="text-sm text-muted-foreground mt-1">
        This helps VirtuStaff.ai create content that matches your brand's tone and style.
      </p>
    </div>
  );
};

export default BrandVoiceSection;
